import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";

const StatsBar = lazy(() => import("@/components/StatsBar"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const AITechSection = lazy(() => import("@/components/AITechSection"));
const GlobalReachSection = lazy(() => import("@/components/GlobalReachSection"));
const ConsultingSection = lazy(() => import("@/components/ConsultingSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => (
  <div className="min-h-screen">
    <Navbar />
    <HeroSection />
    <Suspense fallback={null}>
      <StatsBar />
      <ServicesSection />
      <AITechSection />
      <GlobalReachSection />
      <ConsultingSection />
      <ContactSection />
      <Footer />
    </Suspense>
  </div>
);

export default Index;
